import { Divider, Grid2 } from "@mui/material";
import "./ReviewDrugOrder.css";
import { useNavigate } from "react-router-dom";
import Loader from "../../../../components/Loader";

const ReviewDrugOrder = ({
  data,
  setReviewOrderConfirm,
  orderType,
  sourceDepot,
  destinationDepot,
  destinationSite,
  type,
  submitOrder,
  load,
}) => {
  const navigate = useNavigate();
  return (
    <>
      {load ? (
        <Loader />
      ) : (
        <div className="content-body">
          <p className="bread-crumbs-link-container">
            <button className="bread-crumbs-btn" onClick={() => navigate("/")}>
              Home
            </button>{" "}
            |{" "}
            <button
              className="bread-crumbs-btn"
              onClick={() => navigate("/drug-shipment-management")}
            >
              Drug Order Management
            </button>{" "}
            | <button className="bread-crumbs-btn">Drug Order</button>|{" "}
            <button className="bread-crumbs-btn">Review Order</button>-{" "}
            <b style={{ color: "gray" }}>
              {localStorage?.getItem("studyName")}
            </b>
          </p>
          <Grid2
            container
            alignItems="center"
            justifyContent="space-between"
            sx={{ width: "100%", margin: "0 auto" }}
          >
            <Grid2 item md={12}>
              <p className="page-heading">Review Order</p>
            </Grid2>
          </Grid2>
          <div className="review-drug-detail-main-container">
            <div className="review-drug-detail-container">
              <div className="review-drug-detail">
                <span className="review-drug-detail-name">Order Type</span>
                <span>{orderType}</span>
              </div>
              <div className="review-drug-detail">
                <span className="review-drug-detail-name">Source Depot</span>
                <span>{sourceDepot}</span>
              </div>
              {orderType === "Depot To Depot" ? (
                <div className="review-drug-detail">
                  <span className="review-drug-detail-name">
                    Destination Depot
                  </span>
                  <span>{destinationDepot}</span>
                </div>
              ) : (
                <div className="review-drug-detail">
                  <span className="review-drug-detail-name">
                    Destination Site
                  </span>
                  <span>{destinationSite}</span>
                </div>
              )}
              <div className="review-drug-detail">
                <span className="review-drug-detail-name">
                  Order Selection Type
                </span>
                <span>{type}</span>
              </div>
            </div>
            <div className="review-drug-detail-buttons-container">
              <button className="create-btn big-btn" onClick={submitOrder}>
                Submit Order
              </button>
              <button
                className="create-btn-outlined big-btn"
                onClick={() => setReviewOrderConfirm(false)}
              >
                Edit Order
              </button>
            </div>
          </div>
          <div className="review-drug-cart-container">
            <span className="review-drug-cart-heading">{type}</span>
            <Divider sx={{ marginTop: "10px" }} />
            {type === "Sequence" ? (
              <>
                {data && data?.length > 0 && (
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <div className="sequence-drug-cart-container-review">
                      {data &&
                        data?.map((item) => (
                          <div className="sequence-drug-cart-item">
                            <div className="sequence-drug-cart-name-container">
                              {item?.type}
                              <div className="sequence-drug-cart-name-item">
                                Range : {item?.from} - {item?.to}
                              </div>
                            </div>
                            <div className="sequence-drug-cart-qty-del-container">
                              <h3>
                                <i>Qty</i>. {item?.ordered}
                              </h3>
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                )}
              </>
            ) : (
              <>
                {data && data.length > 0 && (
                  <Grid2 size={{ xl: 5, md: 5, lg: 5, sm: 12, xs: 12 }}>
                    <div className="drug-cart-container-review">
                      {data &&
                        data.length > 0 &&
                        data?.map((drug) => (
                          <div
                            style={{
                              display: "block",
                              justifyContent: "space-between",
                              alignItems: "baseline",
                              border: "1px solid #ccc",
                              borderRadius: "5px",
                              padding: "5px",
                              marginBottom: "2px",
                            }}
                            key={drug?.uniqueId}
                          >
                            <h3 style={{ margin: "10px", marginTop: "0px" }}>
                              {drug?.lotName}
                            </h3>
                            {drug?.quantity?.map((item, index) => (
                              <div key={index} style={{ margin: "10px" }}>
                                <span>{item.name}</span> -{" "}
                                <span>{item.quantity}</span>
                              </div>
                            ))}
                          </div>
                        ))}
                    </div>
                  </Grid2>
                )}
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ReviewDrugOrder;
